import { render, staticRenderFns } from "./SettingsSummary.vue?vue&type=template&id=dd6159b4&scoped=true"
import script from "./SettingsSummary.vue?vue&type=script&lang=js"
export * from "./SettingsSummary.vue?vue&type=script&lang=js"
import style0 from "./SettingsSummary.vue?vue&type=style&index=0&id=dd6159b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6159b4",
  null
  
)

export default component.exports